



















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { OForm, ORules } from '@/types/views/login';

const namespace = 'user';
@Component({})
export default class Login extends Vue {
  @Action('login', { namespace })
  private Login: any;
  private captcha: string = process.env.VUE_APP_API + '/account/captcha';
  private form: OForm = {
    username: '',
    password: '',
    captcha: ''
  }
  private readonly rules: ORules = {
    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
  }
  private mounted() {
    this.updateCaptcha();
    // 本地开发环境填充账号密码
    process.env.NODE_ENV === 'LOCAL' ? this.setAccountLocal() : false
  }
  /**
   * 按需引入本地环境需求文件
   * 然后填充账号密码
   */
  private setAccountLocal () {
    const local = import('@/utils/local')
    local.then(module => {
      this.form = module.default.setAccount(this.form)
    })
  }
  /**
   * 更新图片识别码
   */
  private updateCaptcha() {
    this.captcha =
      process.env.VUE_APP_API + '/account/captcha?r=' + Math.random();
  }
  private login(formName: string) {
    // this.$refs[formName]对象上未声明validate方法
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        try {
          let login = await this.Login({
            username: this.form.username,
            password: this.form.password,
            captcha: this.form.captcha
          });
          this.$message.success('登录成功');
          this.$router.push('/dashboard');
        } catch (err) {
          this.$message.error(err.message);
        }
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
}
